// Change to storage = localStorage if you want to persist log-in accross tabs
const storage = sessionStorage;

const LocalStorageHelper = {
	/**
	 * Get the bearer token from local storage
	 * @returns {String}
	 */
	getToken: () => {
		return storage.getItem('wsu_user_token');
	},

	/**
	 * Set the bearer token to local storage
	 * @param {String} token
	 * @returns {void}
	 */
	setToken: (token) => {
		try {
			storage.setItem('wsu_user_token', token);
		} catch (error) {
			console.log(error);
		}
	},


	/**
	 * Remove bearer token item from local storage
	 * @returns {void}
	 */
	removeToken: () => {
		storage.removeItem('wsu_user_token');
	},


	/**
	 * Set the user data to the local storage
	 * @param {String} user
	 * @returns {void}
	 */
	setUser: (user) => {
		// Wrap in a try-catch block to capture error when JSON.stringify fails
		try {
			storage.setItem('wsu_user', JSON.stringify(user));
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Get user data from local storage
	 * @returns {Object}
	 */
	getUser: () => {
		// Wrap in a try-catch block to capture error when JSON.parse fails
		try {
			return JSON.parse(storage.getItem('wsu_user'));
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove user from local storage
	 * @returns {void}
	 */
	removeUser: () => {
		storage.removeItem('wsu_user');
	},

	/**
	 * Set the email data to the local storage
	 * @param {String} email
	 * @returns {void}
	 */
	setEmail: (email) => {
		storage.setItem('wsu_user_email', email);

	},

	/**
	 * Get email data from local storage
	 * @returns {Object}
	 */
	getEmail: () => {
		return storage.getItem('wsu_user_email');
	},

	/**
	 * Remove email from local storage
	 * @returns {void}
	 */
	removeEmail: () => {
		storage.removeItem('wsu_user_email');
	},

	/**
	 * Set the sign-up data to the local storage
	 * @param {Object} user
	 * @returns {void}
	 */
	setSignUpUser: (user) => {
		// Wrap in a try-catch block to capture error when JSON.stringify fails
		try {
			storage.setItem('wsu_sign_up_user', JSON.stringify(user));
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Get email data from local storage
	 * @returns {Object}
	 */
	getSignUpUser: () => {
		// Wrap in a try-catch block to capture error when JSON.parse fails
		try {
			return JSON.parse(storage.getItem('wsu_sign_up_user'));
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove email from local storage
	 * @returns {void}
	 */
	removeSignUpUser: () => {
		storage.removeItem('wsu_sign_up_user');
	}
};

export default LocalStorageHelper;